import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { TableDisplayMode } from '../../models/table-display-mode';

@UntilDestroy()
@Component({
  selector: 'app-table-display-mode',
  templateUrl: './table-display-mode.component.html',
  styleUrls: ['./table-display-mode.component.scss'],
  imports: [MatRadioGroup, FormsModule, ReactiveFormsModule, MatRadioButton, AgrI18nSharedModule],
})
export class TableDisplayModeComponent implements OnInit {
  @Input() initialTableDisplayMode: TableDisplayMode = TableDisplayMode.list;
  @Output() tableDisplayModeChanged: EventEmitter<TableDisplayMode> = new EventEmitter();

  readonly control = new FormControl();

  ngOnInit() {
    this.control.setValue(this.initialTableDisplayMode);

    this.control.valueChanges.pipe(untilDestroyed(this)).subscribe((tableDisplayMode: TableDisplayMode) => this.tableDisplayModeChanged.emit(tableDisplayMode));
  }
}
